var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checkmark--filled_1_",
    "data-name": "checkmark--filled (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M6,12a6,6,0,1,1,6-6A6.01,6.01,0,0,1,6,12ZM3.317,5.422h0L2.641,6.1l2.4,2.4L9.364,4.178,8.684,3.5,5.043,7.143,3.317,5.422Z",
    fill: "#378a05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "inner-path",
    d: "M11.143,15.539,9,13.4l.682-.682,1.461,1.461L14.319,11l.684.679Z",
    transform: "translate(-5.997 -6.801)",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkFilled);
export default __webpack_public_path__ + "static/media/checkmark-filled.68564b2541fc0a694b10d2c0d1ac629d.svg";
export { ForwardRef as ReactComponent };